import { useFeatureFlag } from '@trello/feature-flag-client';

export const useIsInlineInspirationsEnabled = () => {
  return (
    useFeatureFlag<
      | 'ne-control'
      | 'control'
      | 'ne-basic'
      | 'experiment-basic'
      | 'ne-inspiration'
      | 'experiment-inspiration'
    >('mocha.web.inline-inspirations-v2', 'experiment-inspiration', {
      sendExposureEvent: true,
    }) === 'experiment-inspiration'
  );
};
